import { LinkTo } from '@ember/routing';
import { service } from '@ember/service';
import Component from '@glimmer/component';

import type { Service } from 'webapp-types';

import CommonUiIconComponent from 'webapp/components/common/ui-icon';

export default class WizardRouteTemplate extends Component {
	@service('wizard') declare wizardService: Service.Wizard;
	@service('navigation') declare navigationService: Service.Navigation;

	get title() {
		return this.wizardService.title;
	}

	get activeStep() {
		return this.wizardService.activeStep;
	}

	get allSteps() {
		return this.wizardService.allSteps;
	}

	get hideSteps() {
		return (
			this.navigationService.activatedRoute.includes('wizard.starting') &&
			!this.wizardService.showStepsOnWizardStarting
		);
	}

	get isWideView() {
		return this.wizardService.isWideView;
	}

	<template>
		<div id="wrapper-step" class={{this.activeStep}}>
			{{#if this.hideSteps}}
				<h1>{{this.title}}</h1>
			{{else}}
				<div id="steps" class={{if this.isWideView "smart-center-pos"}}>
					{{#each this.allSteps as |step|}}
						{{#unless step.isHidden}}
							<LinkTo
								@route={{step.link}}
								class="{{if step.isSelected 'selected'}}
									{{if step.isCompleted 'completed'}}"
								@disabled={{step.isDisabled}}
							>
								<span class="num">
									{{#if step.isCompleted}}
										<CommonUiIconComponent @name="Check" @size="xs" />
									{{else}}
										{{step.order}}
									{{/if}}
								</span>
								<span class="text">{{step.name}}</span>
							</LinkTo>
						{{/unless}}
					{{/each}}
				</div>
			{{/if}}

			<LinkTo @route="boards" class="close">
				<CommonUiIconComponent @name="Close" @size="sm" />
			</LinkTo>

			<div id="main" class="step-{{this.activeStep}}">
				{{outlet}}
			</div>
		</div>
	</template>
}
